import type { ComponentType } from "react";
import type { LazyRouteFunction, RouteObject } from "react-router-dom";

export function importComponent(importFnc: () => Promise<{ default: ComponentType }>): LazyRouteFunction<RouteObject> {
  return async () => {
    const Component = await importFnc();
    return { Component: Component.default };
  };
}
